import type {
	QuoteStateAddressSlice,
	StopDetails,
} from "~/shared/types/shipment-summary-types";

export const getAddressTypeLabel = (type: string): string => {
	return type === "pickup" ? "Shipper" : "Delivery";
};

export const getPostalCodeProperty = (
	type: string,
	quoteState: QuoteStateAddressSlice,
	property: "city" | "country" | "postalCode" | "state",
): string => {
	const isPickup = type === "pickup";

	switch (property) {
		case "city": {
			const postalCode = isPickup
				? quoteState.pickupPostalCode
				: quoteState.deliveryPostalCode;
			return postalCode?.city?.name || "";
		}
		case "country": {
			const country = isPickup
				? quoteState.pickupCountry
				: quoteState.deliveryCountry;
			return country?.abbreviation || "";
		}
		case "postalCode": {
			const postalCode = isPickup
				? quoteState.pickupPostalCode
				: quoteState.deliveryPostalCode;
			return postalCode?.postalCode || "";
		}
		case "state": {
			const postalCode = isPickup
				? quoteState.pickupPostalCode
				: quoteState.deliveryPostalCode;
			return postalCode?.city?.state?.abbreviation || "";
		}
		default: {
			return "";
		}
	}
};

export const getStopType = (type: string): string => {
	return type === "pickup" ? "Shipper" : "Receiver";
};

export const getNumberFieldValue = (
	address: StopDetails,
	type: string,
): string => {
	if (type === "pickup") {
		return address.puNumber || "";
	}
	if (type === "delivery") {
		return address.deliveryPO || "";
	}
	return "";
};
